<script>
  import { useForm } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import TextField from '../../components/form/text_field.svelte'
  import SelectField from '../../components/form/select_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { Button } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  // Validation is the server's: each change is checked live by a Precognition request to
  // the real create/update action, and again on Save.
  let { sub_category, back_url: backUrl, options = {} } = $props()

  const isEdit = !!sub_category.id
  const url = isEdit ? `/categories/${sub_category.id}` : '/categories'

  const form = useForm({
    sub_category: { category_id: sub_category.category_id, title: sub_category.title, emoji: sub_category.emoji },
    return_to: backUrl
  }).withPrecognition(isEdit ? 'patch' : 'post', url)
  liveValidate(form, 'sub_category')

  const errorFor = (field) => $form.errors[`sub_category.${field}`]

  const submit = (event) => {
    event.preventDefault()
    if (isEdit) $form.patch(url)
    else $form.post(url)
  }
</script>

<Layout>
  <PageHeader title={isEdit ? 'Edit Category' : 'New Category'} subtitle="Sub-category within a parent category" />

  <FormLayout onsubmit={submit}>
    <FormSection title="Details">
      {#if errorFor('base')}<p class="text-sm text-error">{errorFor('base')}</p>{/if}

      <SelectField bind:value={$form.sub_category.category_id} label="Parent Category" name="category_id" options={options.categories ?? []} error={errorFor('category_id')} required />
      <TextField bind:value={$form.sub_category.title} label="Title" name="title" error={errorFor('title')} required />
      <TextField bind:value={$form.sub_category.emoji} label="Emojis" name="emoji" error={errorFor('emoji')} />
    </FormSection>

    {#snippet footer()}
      <Button href={backUrl} variant="ghost" size="sm">Cancel</Button>
      <SubmitButton processing={$form.processing} label="Save" full={false} />
    {/snippet}
  </FormLayout>
</Layout>
